import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgOtpInputComponent } from 'ng-otp-input';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoginService } from '../../services/login.service';
import { Globals } from '../../shared/services/global';
import { HeaderService } from '../../shared/services/header.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent {

  successData: any = {
    heading: 'success.successfullyChanged',
    content: 'success.pinSuccessfullyUpdated',
    btnText: 'success.backToLogin'
  }
  showSuccess: boolean = false;
  showMobileOtpVerification: boolean = false;
  showEmailOtpVerification: boolean = false;
  showPin: boolean = false;

  displayResendCode: boolean = false;
  interval: any = null;
  otp: any;
  icNumber: any;

  showCreatePin: boolean = false;
  showConfirmPin: boolean = false;
  createPin:any;
  confirmPin:any;

  errorMsgs: any;
  translateSubscription: Subscription;
  userDetails: any;
  disableNext:boolean = false;

  @ViewChild(NgOtpInputComponent, { static: false }) otpInput!: NgOtpInputComponent;
  @ViewChild(NgOtpInputComponent, { static: false }) otpInput1!: NgOtpInputComponent;

  constructor(
    private router: Router,
    private headerService: HeaderService,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private globals: Globals
  ) {
    this.translateSubscription = translate.get(['toasterStatus']).subscribe((data: any) => {
      this.errorMsgs = data
    })
  }

  ngOnInit() {
    if (!this.globals.allowForgetPinFlow) {
      this.router.navigate(['/login']);
    }
    localStorage.removeItem('authToken');
    this.headerService.updateHeaderDetails({ displayOnlyLogo: true });
  }

  icNumberNextClick() {
    let body = {
      "iCnumber": this.icNumber
    }
    this.loginService.forgetPinRequest(body).subscribe((res: any) => {
      if (res && res.status && res.status.isSuccess) {
        this.userDetails = res.content;
        this.showMobileOtpVerification = true;
        setTimeout(() => {
          var fiveMinutes = 60 * 2,
            display = document.querySelector('#time');
          this.timer(fiveMinutes, display);
        }, 100)
      }
      else{
        this.toastrService.error(res.status.statusMessage,this.errorMsgs['toasterStatus'].error);
      }
    })

  }

  timer(duration: any, display: any) {
    let self = this;
    var timer = 60 * 2, diff, minutes, seconds;
    var start = Date.now()
    if (self.interval !== null) {
      clearInterval(self.interval);
    }

    self.interval = setInterval(function () {
      diff = duration - (((Date.now() - start) / 1000) | 0);
      minutes = (diff / 60) | 0;
      seconds = (diff % 60) | 0;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = minutes + ":" + seconds;

      if (--timer < 0) {
        self.displayResendCode = true;
        timer = duration;
        display.textContent = '';
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(self.interval);
      self.displayResendCode = true;
      timer = duration;
      display.textContent = '';
    }, 120000);
  }

  onOtpChange(otp: any) {
    this.otp = otp;
  }

  verifyOtp() {
    if (this.showMobileOtpVerification) {
      let body = {
        "tokenType": "ForgetPasswordMobile",
        "otpCode": this.otp
      }
      this.loginService.verifyOtpToken(body).subscribe((res: any) => {
        if (res && res.status && res.status.isSuccess) {
          this.showEmailOtpVerification = true;
          this.showMobileOtpVerification = false;
          this.showPin = false;
          this.otpInput.setValue(null);
          let eleId = this.otpInput.getBoxId(0);
          this.otpInput.focusTo(eleId);
          this.displayResendCode = false;
          setTimeout(() => {
            var fiveMinutes = 60 * 2,
              display = document.querySelector('#time');
            this.timer(fiveMinutes, display);
          }, 100)
        }
        else {
          this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error);
        }
      })

    }
    else if (this.showEmailOtpVerification) {
      let body = {
        "tokenType": "ForgetPasswordEmail",
        "otpCode": this.otp
      }
      this.loginService.verifyOtpToken(body).subscribe((res: any) => {
        if (res && res.status && res.status.isSuccess) {
          this.showPin = true;
          this.showMobileOtpVerification = false;
          this.showEmailOtpVerification = false;
          this.showCreatePin = true;
        }
        else {
          this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error);
        }
      })

    }
  }

  backClick() {
    if (this.showPin) {
      if (this.showConfirmPin) {
        this.showCreatePin = true;
        this.showConfirmPin = false;
        this.otpInput1.setValue(null);
        this.otp = null;
        let eleId = this.otpInput1.getBoxId(0);
        this.otpInput1.focusTo(eleId);
      }
      else if (this.showCreatePin) {
        this.showPin = false;
        this.showEmailOtpVerification = true;
        this.displayResendCode = false;
        setTimeout(() => {
          var fiveMinutes = 60 * 2,
            display = document.querySelector('#time');
          this.timer(fiveMinutes, display);
        }, 100)
        this.otpInput.setValue(null);
        this.otp = null;
        let eleId = this.otpInput.getBoxId(0);
        this.otpInput.focusTo(eleId);
      }
    }
    else if (this.showEmailOtpVerification) {
      this.showMobileOtpVerification = true;
      this.showEmailOtpVerification = false;
      this.showPin = false;
      this.otpInput.setValue(null);
      this.otp = null;
      let eleId = this.otpInput.getBoxId(0);
      this.otpInput.focusTo(eleId);
      this.displayResendCode = false;
      setTimeout(() => {
        var fiveMinutes = 60 * 2,
          display = document.querySelector('#time');
        this.timer(fiveMinutes, display);
      }, 100)

    }
    else if (this.showMobileOtpVerification) {
      this.showMobileOtpVerification = false;
      this.showEmailOtpVerification = false;
      this.showPin = false;
    }
    else if (!this.showMobileOtpVerification && !this.showEmailOtpVerification && !this.showPin && !this.showSuccess) {
      this.router.navigate(['/login']);
    }
  }

  onPinChange(pin:any){
    if(this.showCreatePin){
      this.createPin = pin;
    }
    else if(this.showConfirmPin){
      this.confirmPin = pin;
    }
  }

  confirmPinClick() {
    if (this.showCreatePin) {
      this.showConfirmPin = true;
      this.showCreatePin = false;
      this.otp = undefined;
      this.otpInput1.setValue(null);
      let eleId = this.otpInput1.getBoxId(0);
      this.otpInput1.focusTo(eleId);
    }
    else if (this.showConfirmPin) {
      if(this.createPin !== this.confirmPin){
        this.toastrService.error('Incorrect details. Try again.',this.errorMsgs['toasterStatus'].error);
        return;
      }
      let body = {
        "appPin": this.createPin,
        "confirmAppPin": this.confirmPin
      }
      this.loginService.createAppPin(body).subscribe((res:any) => {
        if(res && res.status && res.status.isSuccess){
          this.showSuccess = true;
          this.showPin = false;
        }
        else{
          this.toastrService.error(res.status.statusMessage,this.errorMsgs['toasterStatus'].error);
        }
      })
      
    }
  }

  isNumberKey(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && ((charCode < 48 || charCode > 57)))
      return false;
    return true;
  }

  resendClick() {
    if (this.showMobileOtpVerification) {
      let body = {
        "tokenType": "ForgetPasswordMobile",
        "phoneNumber": this.userDetails?.mobileNo
      }
      this.loginService.sendMobileOtp(body).subscribe((res: any) => {
        if (res && res.status && res.status.isSuccess) {
          this.displayResendCode = false;
          setTimeout(() => {
            var fiveMinutes = 60 * 2,
              display = document.querySelector('#time');
            this.timer(fiveMinutes, display);
          }, 100)
          this.toastrService.success(res.status.statusMessage, this.errorMsgs['toasterStatus'].success);
        }
        else {
          this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error);
        }
      })
    }
    else if (this.showEmailOtpVerification) {
      let body = {
        "tokenType": "ForgetPasswordEmail",
        "emailAddress": this.userDetails?.userEmail
      }
      this.loginService.sendEmailOtp(body).subscribe((res: any) => {
        if (res && res.status && res.status.isSuccess) {
          this.displayResendCode = false;
          setTimeout(() => {
            var fiveMinutes = 60 * 2,
              display = document.querySelector('#time');
            this.timer(fiveMinutes, display);
          }, 100)
          this.toastrService.success(res.status.statusMessage, this.errorMsgs['toasterStatus'].success);
        }
        else {
          this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error);
        }
      })
    }
  }
}
